import { QTextEdit } from "../CoreApp/QTextEdit";

export function CreateTextEdit() {
  var te = new QTextEdit();
  te.fActiveSelection = true;
  te.InitTextEdit();
  return te;
}
